import { routes } from 'routes';

export const generalFilterIsVisibleOn = [
    routes.FleetOverview, /* REMOVE THIS LINE IF GENERAL FILTER NOT NEEDED IN FLEETS DASHBOARD */
    routes.FleetDashboard, /* REMOVE THIS LINE IF GENERAL FILTER NOT NEEDED IN FLEETS DASHBOARD */
    routes.ConditionMonitoring,
    routes.PowertrainAndAssetDetails,
    routes.Tools,
    routes.Reports,
    routes.NotificationSettings
];
